var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRedondo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 106,
    viewBox: "0 0 83 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "url(#paint0_linear_50_2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 86.5C7.5 91.5 1.99994 105.5 1.99994 105.5C1.99994 105.5 1.14862 93.1916 4.49994 86.5C8.59746 78.3184 15.9999 75 22.4999 71.5C29 68 40.9457 67.0139 49.4999 59.5C56.9487 52.9572 60.3753 48.5605 62.9999 39C66.0052 28.0529 60.9999 10 60.9999 10C60.9999 10 77.4999 25 79.4999 32C81.4999 39 83 47.5 81.4999 56C79.9999 64.5 74.6843 70.2856 65.9999 75C48.5 84.5 23.4649 80.8567 14.9999 86.5Z",
    fill: "#F05D64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4316 18C69.4358 18.0038 69.8613 18.3917 70.582 19.0684C74.755 23.5401 78.9811 28.6732 79.9316 32C81.9316 39 83.4317 47.5 81.9316 56C80.4316 64.5 75.116 70.2856 66.4316 75C52.7145 82.4465 34.3674 81.817 23 83.915C25.6097 82.2596 28.3423 80.8942 30.9316 79.5C37.4317 76 49.3774 75.0138 57.9316 67.5C65.3804 60.9572 68.807 56.5605 71.4316 47C74.4353 36.0586 69.4369 18.0188 69.4316 18Z",
    fill: "#B0324B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_50_2",
    x1: 48.5,
    y1: 12.5,
    x2: 7.5,
    y2: 42.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252850"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRedondo);
export default __webpack_public_path__ + "static/media/logo_redondo.b927b7bf81383c1b5f9e642e6526d7c6.svg";
export { ForwardRef as ReactComponent };